import styled from 'styled-components';

import { variables } from '../../../styles/variables';

const MaintenanceModePageWrapper = styled.div`
  word-wrap: break-word;

  .header {
    width: 100vw;
    height: auto;
    border-bottom: 4px solid ${variables.colorDecorator};

    img {
      margin: 0 0 16px 32px;
    }
  }

  .content {
    margin: 32px;

    .withBold {
      font-weight: 700;
    }

    .withPaddingBottom {
      padding-bottom: 32px;
    }

    img {
      margin: 32px 0;
    }

    h1 {
      font-size: 40px;
      font-weight: 700;
    }

    h2 {
      font-size: 24px;
      margin-bottom: 64px;
      font-weight: 700;
    }

    h3 {
      font-size: 20px;
    }

    h4 {
      margin: 0;
    }

    h5 {
      font-size: 12px;
      margin: 0 0 0 8px;
      display: inline-block;
    }

    p {
      margin: 0;
    }
  }
`;

export { MaintenanceModePageWrapper };
